import { useEffect } from "react";
import { queryClient } from "../../../App";
import { HttpClientError } from "../../../providers/HttpClient";
import useDownloadEmployeeImportJobValidationFileApiService from "../services/api/DownloadEmployeeImportJobValidationFileApiService";
import { useToasts } from "../../../providers/notifications/ToastsContext";

export default function DownloadValidationFileImportJobHook(): {
  downloadValidationFile: (id: number) => void;
} {
  const {
    isSuccess,
    isError,
    mutate,
    data: downloadValidationFileResponse,
    error,
  } = useDownloadEmployeeImportJobValidationFileApiService();
  const { showToast } = useToasts();

  const downloadValidationFile = (id: number): void => {
    mutate(id);
  };

  useEffect(() => {
    if (isError) {
      showToast({
        strapiId: "employee_data_import_file_dowload_failed",
        data: { message: HttpClientError(error) },
      });
    }
  }, [isError, error]);

  useEffect(() => {
    if (isSuccess) {
      window.location.assign(downloadValidationFileResponse.file_url);
      showToast({
        strapiId: "employee_data_import_validation_file_downloaded",
      });
      queryClient.invalidateQueries(["EmployeeImportJobListApiService"]).then();
    }
  }, [isSuccess]);

  return {
    downloadValidationFile,
  };
}
